import React from 'react';
import colors from 'themes/colors';
import SvgIcon from '@material-ui/core/SvgIcon';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { ReactComponent as RecyclingSvg } from 'assets/images/svg/recycling.svg';

export const DRIVER_TAGS = ['NEW - 1ST ROUTE', 'NEW'];

// Chip config per driver tag, keyed by normalizeTag; unlisted tags use the default skewed chip
export const DRIVER_TAG_CONFIG = {
  'dsp': {
    bgColor: '#4cbb4c',
  },
  '3p': {
    bgColor: '#4cbb4c',
  }
  // Define new driver tag config here
};

// Highest priority first; matched ignoring case and `_` vs space
export const ASSIGNMENT_PRIORITY_TAGS = ['pickup_returns', 'military_base', 'business', 'VIP', 'Uber eligible'];
export const MAX_VISIBLE_TAGS = 6;

// Chip config per tag, keyed by normalizeTag (case / `_` vs space insensitive); unlisted tags use the default chip
export const ASSIGNMENT_TAG_CONFIG = {
  uber_eligible: {
    bgColor: colors.black
  },
  commercial: {
    icon: <AccessTimeIcon fontSize="inherit" />
  },
  // TODO: Use Recycle MUI Icon directly when bump to MUI v5-9
  pickup_returns: {
    bgColor: '#0b6b2e',
    icon: <SvgIcon component={RecyclingSvg} viewBox="0 0 24 24" fontSize="inherit" />
  },
  post_secondary_school: {
    label: 'School',
    tooltip: 'Post Secondary School'
  },
  military_base: {
    label: 'Military',
    tooltip: 'Military Base'
  },
  multi_dwelling_unit: {
    label: 'MDU',
    tooltip: 'Multi Dwelling Unit'
  },
  // Define new tag config here
};

export const ASSIGNMENT_MAP = {
  unassigned: {
    color: '#bebfc0',
    key: 'UNASSIGNED',
    title: 'UNASSIGNED',
    description: 'Unassigned',
    tooltip: 'These routes are not assigned to any driver or DSP.',
  },
  pending: {
    color: '#fa6725',
    key: 'PENDING',
    title: 'PENDING',
    description: 'Pending',
    tooltip: 'These routes are assigned but not yet started.',
  },
  on_the_way: {
    color: '#fa6725',
    key: 'ON_THE_WAY',
    title: 'ON THE WAY',
    description: 'On the way',
    tooltip: 'These routes are active and the driver is en route to pickup.',
  },
  picking_up: {
    color: '#fa6725',
    key: 'PICKING_UP',
    title: 'PICKING UP',
    description: 'Picking up',
    tooltip: 'These routes have the driver arrived and ready for pickup.',
  },
  inactive: {
    color: '#000000',
    key: 'INACTIVE',
    title: 'INACTIVE',
    description: 'Inactive',
    tooltip: 'These routes are deactivated.',
  },
  completed: {
    color: '#4abc4e',
    key: 'COMPLETED',
    title: 'COMPLETED',
    description: 'Completed',
    tooltip: 'These routes have been marked as completed.',
  },
  in_progress: {
    color: '#fbc04f',
    key: 'IN_PROGRESS',
    title: 'IN PROGRESS',
    description: 'In progress',
    tooltip: 'These routes are active and not currently at risk.',
  },
  risky_stalled: {
    color: '#0f068e',
    key: 'RISKY_STALLED',
    title: 'AT RISK - STALLED',
    description: 'At Risk - Stalled',
    tooltip: 'These routes have no delivery activity for a long period of time and may need attention.',
  },
  risky_return: {
    color: '#1100f6',
    key: 'RISKY_RETURN',
    title: 'AT RISK - RETURN',
    description: 'At Risk - Return',
    tooltip: 'These routes have returning stops with no activity for a long period of time.',
  },
  risky_notd: {
    color: '#887fff',
    key: 'RISKY_NOTD',
    title: 'AT RISK - NOTD',
    description: 'At Risk - NOTD',
    tooltip: 'These routes are estimated to finish after the latest delivery time window.',
  },
  pending_complete: {
    color: '#3A656F',
    key: 'PENDING_COMPLETE',
    title: 'PENDING COMPLETE',
    description: 'Pending Complete',
    tooltip: 'These routes have all stops finished and are awaiting final completion.',
  },
  pending_return: {
    color: '#A3DCFF',
    key: 'PENDING_RETURN',
    title: 'PENDING RETURN',
    description: 'Pending Return',
    tooltip: 'These routes have failed stops and are awaiting return processing.',
  },

};
